import { globalStyle, style, styleVariants } from "@vanilla-extract/css";
import { vars } from "plos/src/styles";
import {
  NEWS_CONTAINER_BREAKPOINTS,
  newsContainer,
} from "../../../styles/containers.css";

export const newsLink = style({
  display: "block",
  flex: "1 0 100px",
  textDecoration: "none",
});

export const newsItemStyles = style({
  display: "flex",
  flexDirection: "column",
  gap: vars.space["2xs"],
  height: "100%",
  color: vars.colors.onSurface,
});

const bodyBase = style({
  display: "flex",
  justifyContent: "space-between",
  gap: vars.space.s,
  height: "100%",
});

const compactStyles = style([
  bodyBase,
  {
    flexDirection: "column-reverse",
    justifyContent: "flex-end",
  },
]);

export const newsItemBody = styleVariants({
  default: [
    bodyBase,
    {
      "@container": {
        [`${newsContainer} (min-width: ${NEWS_CONTAINER_BREAKPOINTS[1]})`]: {
          flexDirection: "column-reverse",
          justifyContent: "flex-end",
        },
      },
    },
  ],
  compact: [compactStyles],
  scrollable: [
    compactStyles,
    {
      minWidth: "296px",
    },
  ],
});

export const newsTitle = style({
  flex: "0 0 58%",
  fontSize: vars.fontSizes.heading.m,
  "@container": {
    [`${newsContainer} (min-width: ${NEWS_CONTAINER_BREAKPOINTS[1]})`]: {
      flex: "0 1 auto",
    },
  },
});

export const newsTag = style({
  color: vars.colors.onSurface,
  fontSize: vars.fontSizes.body.s,
});

globalStyle(`${newsLink}:hover ${newsTitle}`, {
  textDecoration: "underline",
});

export type NewsItemVariants = keyof typeof newsItemBody;
